exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-scrollbar .el-scrollbar__bar{opacity:1 !important}\n", ""]);

// exports
